import * as React from 'react';

interface IGlobalContextMenuState {
    show: boolean;
    position: { x: number; y: number };
    url?: string;
}

export default class GlobalContextMenu extends React.Component<{}, IGlobalContextMenuState> {
    constructor(props: {}) {
        super(props);
        this.state = {
            show: false,
            position: { x: 0, y: 0 },
            url: undefined,
        };
    }

    componentDidMount() {
        window.addEventListener('showGlobalContextMenu', this.handleShowContextMenu);
        window.addEventListener('click', this.handleCloseContextMenu); // Close menu on click outside
    }

    componentWillUnmount() {
        window.removeEventListener('showGlobalContextMenu', this.handleShowContextMenu);
        window.removeEventListener('click', this.handleCloseContextMenu);
    }

    handleShowContextMenu = (event: CustomEvent) => {

        let { x, y, url } = event.detail;

        // Adjust position if the menu goes out of bounds
        const viewportWidth = window.innerWidth;
        const viewportHeight = window.innerHeight;
        const menuWidth = 150; // Width of the menu
        const menuHeight = 200; // Height of the menu

        if (x + menuWidth > viewportWidth) {
            x = viewportWidth - menuWidth; // Adjust X position
        }
        if (y + menuHeight > viewportHeight) {
            y = viewportHeight - menuHeight; // Adjust Y position
        }

        this.setState({
            show: true,
            position: { x, y },
            url,
        });
    }

    handleCloseContextMenu = () => {
        this.setState({ show: false });
    }

    handleOpenInNewTab = () => {
        if (this.state.url) {
            window.open(this.state.url, '_blank'); // Open the URL in a new tab
        }
        this.handleCloseContextMenu(); // Close the context menu
    }

    render() {
        const { show, position } = this.state;

        if (!show) return null;

        return (
            <div
                className="custom-context-menu"
                style={{
                    position: 'fixed',
                    top: position.y,
                    left: position.x,
                    backgroundColor: '#fff',
                    border: '1px solid #ccc',
                    borderRadius: '4px',
                    boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
                    zIndex: 9999, // Ensure it's above other elements
                    display: 'block',
                    minHeight: '50px',
                    width: '120px',
                }}
            >
                <div className="context-menu-item" onClick={this.handleOpenInNewTab}>
                    Open in new tab
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/GlobalContextMenu.tsx